import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'features';
export const keyPrefix = 'edit_role';
export const useEditRoleTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns, { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    edit_button: 'Изменить',
    toast_success: 'Роль успешно изменена',
    toast_error: 'Не удалось изменить роль',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    edit_button: 'Edit',
    toast_success: 'Role updated successfully',
    toast_error: 'Failed to update role',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    edit_button: 'Editar',
    toast_success: 'Rol actualizado con éxito',
    toast_error: 'Error al actualizar el rol',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    edit_button: 'Editar',
    toast_success: 'Função atualizada com sucesso',
    toast_error: 'Falha ao atualizar função',
  },
}) : {}) as Record<string, unknown>;
